import { Grid, Typography } from '@mui/material';
import React from 'react';
import { DrawerBoxComponent } from '../DrawerBoxComponent/DrawerBoxComponent';
import StatusIcon from '@mui/icons-material/FiberManualRecord';
import { APPOINTMENTS } from '../../shared/Strings';

export const AppointmentMedicalHistory = ({ data }) => {
  return (
    <DrawerBoxComponent>
      <Grid container spacing={2} direction="column">
        <Grid item>
          <Typography variant="navSelected">
            {APPOINTMENTS.MEDICAL_HISTORY}
          </Typography>
        </Grid>
        <Grid item>
          <Grid container spacing={1} direction="column">
            {data?.map((item, index) => (
              <Grid item key={index}>
                <Grid container spacing={1} alignItems="center">
                  <Grid item>
                    <Typography variant="h5" color="#33333">
                      {item?.condition} : {item?.value}
                    </Typography>
                  </Grid>
                  {item.description && (
                    <Grid item>
                      <Typography variant="h5" color="#33333">
                        <StatusIcon
                          htmlColor="black"
                          sx={{
                            height: 10,
                            width: 10,
                            mr: 0.5,
                            ml: 1,
                          }}
                        />
                        {item?.description}
                      </Typography>
                    </Grid>
                  )}
                </Grid>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </DrawerBoxComponent>
  );
};
